import * as React from 'react';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import './TournamentWaitingListSuccessModal.scss';

interface Props {
  isOpen: boolean;
  tournamentName?: string;
  onClose: () => void;
}

export const TournamentWaitingListSuccessModal: React.FC<Props> = ({ isOpen, tournamentName, onClose }) => (
  <SimpleModal
    isOpen={isOpen}
    showHeader={false}
    bodyClassName="waitingListSuccessModalHost"
    dialogStyle={{ maxWidth: 560 }}
  >
    <div className="waitingListSuccessModal">
      <header className="waitingListSuccessModal__head">
        <span className="waitingListSuccessModal__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path d="m6.5 12.5 3.5 3.5 7.5-8" />
          </svg>
        </span>
        <div>
          <h2>Added to waiting list</h2>
          <p>Your waiting-list booking has been confirmed.</p>
        </div>
        <button type="button" className="waitingListSuccessModal__close" onClick={onClose} aria-label="Close">
          <span>&times;</span>
        </button>
      </header>

      <div className="waitingListSuccessModal__body">
        <p className="waitingListSuccessModal__message">
          Your school has been added to the waiting list for {tournamentName || 'this tournament'}.
        </p>
        <div className="waitingListSuccessModal__next">
          <h3>What happens next</h3>
          <ul>
            <li>You can view your current queue position in your waiting list tournaments.</li>
            <li>
              If a place becomes available and the organisers move your school into the participant list, you will
              receive a notification.
            </li>
            <li>Once that happens, you will be able to manage your participation from your upcoming tournaments.</li>
          </ul>
        </div>
      </div>

      <footer className="waitingListSuccessModal__foot">
        <button type="button" onClick={onClose}>
          Done
        </button>
      </footer>
    </div>
  </SimpleModal>
);

TournamentWaitingListSuccessModal.displayName = 'TournamentWaitingListSuccessModal';
